/**
 * O nome curto de um caminho da árvore do e-Niterói, para a coluna da tabela.
 *
 * A entidade chega como "Prefeitura de Niterói > SEPLAG - Secretaria de Planejamento…" e o grupo
 * como "Sustentação DBSeller > Financeiro". A raiz é a MESMA em todas as linhas — repeti-la nove
 * vezes por tela era o que fazia as duas colunas cortarem no meio da palavra ("Prefeitura de
 * Niterói > F…") justamente a parte que distingue um chamado do outro. Fica o último ramo e, quando
 * ele começa por sigla ("SEPLAG - Secretaria…"), só a sigla, que é como a fiscalização fala.
 *
 * O caminho inteiro não se perde: a célula o leva no `title`, e o detalhe do chamado o mostra.
 *
 * @param caminho o texto como a API devolve
 * @returns o ramo final, ou a sigla dele
 */
export function nomeCurtoDoRamo(caminho: string): string {
  const ramo = caminho.split(' > ').at(-1)?.trim() || caminho.trim()
  const sigla = SIGLA_NO_INICIO.exec(ramo)?.[1]
  return sigla ?? ramo
}

/** "SMF - Secretaria…", "FMS / SMS - Fundo…": maiúsculas, dígitos e barra antes de " - ". */
const SIGLA_NO_INICIO = /^([A-ZÁÉÍÓÚÂÊÔÃÕÇ0-9]{2,}(?:\s?\/\s?[A-ZÁÉÍÓÚÂÊÔÃÕÇ0-9]{2,})*)\s+[-–]\s+\S/
